function Legal({
  title,
  updated,
  sections,
}: {
  title: string;
  updated: string;
  sections: { title: string; body: string[] }[];
}) {
  return (
    <article className="legal">
      <h1>{title}</h1>
      <p className="updated">{updated}</p>
      {sections.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          {section.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>
      ))}
    </article>
  );
}

export function PrivacyPage() {
  return (
    <Legal
      title="Privacy Policy"
      updated="Updated 23 August 2026"
      sections={[
        {
          title: 'Who processes data',
          body: [
            'Operator: Damir Rashidov. Contact: damir@rashidov.eu. The UllSpeak app (com.ullspeak.app) and the site ullspeak.com.',
          ],
        },
        {
          title: 'What we collect',
          body: [
            'Account: email and name provided by Sign in with Apple, plus an internal user id.',
            'Learning: sessions, text messages from the dialogue, progress on speech patterns and words.',
            'Technical: session tokens and operational logs of model interaction. We do not store voice recordings.',
          ],
        },
        {
          title: 'Voice and microphone',
          body: [
            'The microphone is used only during a voice session. Audio goes from the device to the OpenAI Realtime API over WebRTC. We do not record or store audio on our servers.',
          ],
        },
        {
          title: 'Why we need it',
          body: [
            'To sign you in, run the dialogue, remember progress, and fix failures. No ads, no data sales, no profiling for third parties.',
          ],
        },
        {
          title: 'Who we share with',
          body: [
            'Apple — Sign in with Apple.',
            'OpenAI — real-time processing of voice and dialogue text. Their policy: https://openai.com/policies/privacy-policy',
            'Hosting and the database — to run the app. Audio does not pass through them.',
          ],
        },
        {
          title: 'Retention and deletion',
          body: [
            'Account and progress stay while the account exists. To delete everything, email damir@rashidov.eu. We will remove the user, sessions, messages, progress, and tokens.',
          ],
        },
        {
          title: 'Children',
          body: [
            'The app is not directed at children under 13. If you believe we received a child’s data, write to us and we will delete it.',
          ],
        },
        {
          title: 'Changes',
          body: ['If this policy changes, we will update this page. The date is at the top.'],
        },
      ]}
    />
  );
}

export function TermsPage() {
  return (
    <Legal
      title="Terms of Use"
      updated="Updated 23 August 2026"
      sections={[
        {
          title: 'The service',
          body: [
            'UllSpeak is a voice trainer for conversational speech. The product is in development: features may change, disappear, or fail.',
          ],
        },
        {
          title: 'Account',
          body: [
            'Sign-in is only through Sign in with Apple. You are responsible for your Apple ID. One person, one account, for personal learning — not for reselling access.',
          ],
        },
        {
          title: 'Acceptable use',
          body: [
            'Do not break the service, extract other people’s data, bypass limits, or use the app to harm anyone. The voice dialogue goes through a third-party language model — do not treat it as legal, medical, or other professional advice.',
          ],
        },
        {
          title: 'Intellectual property',
          body: [
            'The name, app, method, and materials belong to Damir Rashidov. What you say remains yours; we need a license to process it so training can run.',
          ],
        },
        {
          title: 'Disclaimer',
          body: [
            'The service is provided “as is”. We do not promise uptime, model accuracy, or a specific language outcome.',
          ],
        },
        {
          title: 'Contact',
          body: ['Questions about these terms: damir@rashidov.eu.'],
        },
      ]}
    />
  );
}

export function SupportPage() {
  return (
    <article className="legal">
      <h1>Support</h1>
      <p className="lead">
        UllSpeak is still in development. If something breaks or you need help, write to us.
      </p>
      <p>We usually reply within a few days. Include the Apple ID you used and what happened.</p>
      <p>
        Email: <a href="mailto:damir@rashidov.eu">damir@rashidov.eu</a>
      </p>
      <p>
        To delete your account and data, email the same address with “delete account” in the
        subject. We will remove the profile, sessions, messages, progress, and tokens.
      </p>
    </article>
  );
}
